import { NavLink } from 'react-router-dom';
import { SIDEBAR_MODULES } from '@config/auth';
import { moduleToPath } from '@constant/routes';
import { useAuth } from '@context/auth-context';

import type { SidebarProps } from '@component/layout/types';

export default function Sidebar({ onLogout }: SidebarProps) {
  const { canAccess } = useAuth();

  return (
    <div className="sidebar">
      {SIDEBAR_MODULES.map((mod) => {
        if (!canAccess(mod.id)) return null;
        const path = moduleToPath(mod.id);
        if (!path) return null;
        return (
          <NavLink
            key={mod.id}
            to={path}
            className={({ isActive }) => `sb${isActive ? ' on' : ''}`}
            title={mod.title}
          >
            <img src={mod.icon} style={{ width: '60%' }} alt="" />
            <span className="sb-tooltip">{mod.tooltip}</span>
          </NavLink>
        );
      })}
      <div className="sb-bot">
        <button type="button" className="sb" title="Logout" onClick={onLogout} style={{ color: '#fff' }}>
          <img src="/img/logout.png" style={{ width: '60%' }} alt="" />
          <span className="sb-tooltip">Logout</span>
        </button>
      </div>
    </div>
  );
}
